import { useNow } from '@/composables/game/time'
import { computed, ref, watch } from 'vue'
import api from '@/services/api'
import { PVP_GAME_STATUS, PVP_GAME_STRATEGY } from '@/types/shared/pvp'
import { usePlayer } from '@/composables/game/player'

export const usePvpGame = () => {
  const { now } = useNow()
  const { updatePlayer } = usePlayer()
  const matchId = ref('')
  const startTimestamp = ref(0)
  const matchStatus = ref<null | PVP_GAME_STATUS>(null)
  const lastCheckTimestamp = ref(0)
  async function playGame(strategy: PVP_GAME_STRATEGY) {
    matchStatus.value = PVP_GAME_STATUS.PENDING
    startTimestamp.value = now.value
    lastCheckTimestamp.value = startTimestamp.value
    const result = await api.playPvp(strategy)
    matchId.value = result.matchId

    const clearWatch = watch(now, async (now) => {
      if (now - lastCheckTimestamp.value < 3) {
        return
      }
      lastCheckTimestamp.value = now
      const { match, playerStats } = await api.getPvpMatch(matchId.value)
      if (!match) {
        clearWatch()
        return
      }
      if (match.status === PVP_GAME_STATUS.PENDING) return
      if (playerStats) {
        updatePlayer(playerStats)
      }

      clearWatch()
      matchId.value = ''
      matchStatus.value = match.status
    })
  }

  return {
    playGame: playGame,
    isPending: computed(() => matchStatus.value === PVP_GAME_STATUS.PENDING),
    matchStatus,
    timeElapsed: computed(() => now.value - startTimestamp.value),
  }
}
